import React, { useEffect, useState } from 'react';
import { Grid, Stack } from '@mui/material';
import FormFieldItem, { CreateInventoryFormPanel, formFieldGridColumns, MoreFields } from './FormLayout';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import WeightInput from "../Common/WeightInput"
import {
    system_type_options,
    asset_status_options,
    yes_no_options,
    acquisition_status_options,
    energy_source_type_options,
    phase_options,
    hertz_options,
    charge_capacity_source_type,
    system_status_options
} from './utils';
import PropTypes from 'prop-types';
import Routes from "../../routes"
import { TranslateW } from '../../Utils/Languages/Translate';
import useGetLocationForDropdown from "../../hooks/useGetLocationForDropdown";


const temp_class_options = [
    { id: 1, label: "High" },
    { id: 2, label: "Medium" },
    { id: 3, label: "Low" },
    { id: 4, label: "Dual Temp" },
    { id: 5, label: "Other" }
];

const oil_type_options = [
    { value: "0", label: "AB" },
    { value: "2", label: "Mineral" },
    { value: "1", label: "POE" }
];

const comfort_cooling_options = [
    { id: 10, label: "Air Conditioning" },
    { id: 11, label: "Chiller" },
    { id: 29, label: "Other" }
];

const air_conditioning_options = [
    { value: 108, label: "Air Dryer/Dehumidifier" },
    { value: 31, label: "Air Handling Unit" },
    { value: 13, label: "Blow Through" },
    { value: 33, label: "Chiller" },
    { value: 15, label: "Draw-Through" },
    { value: 30, label: "EWC/Multizone Split(Ductless)" },
    { value: 14, label: "Heat Pump" },
    { value: 24, label: "Other" },
    { value: 11, label: "Package Unit" },
    { value: 32, label: "Roof Top Unit (RTU)" },
    { value: 12, label: "Split System" }
];

const chiller_options = [
    { value: 16, label: "Air Cooled" },
    { value: 17, label: "Evaporative" },
    { value: 18, label: "Water Cooled" }
];

const other_options = [
    { value: 29, label: "Air Curtain" },
    { value: 112, label: "Chilled Water Loop" },
    { value: 28, label: "Data Center Cooling" },
    { value: 33, label: "Chiller" },
    { value: 15, label: "Draw-Through" }
];

const ComfortCooling = ({
    materialTypes,
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    aquireLocationsOptions,
    aquireLocation,
    setAquireLocation,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    systemType,
    setSystemType,
    comfortCoolingType,
    setComfortCoolingType,
    comfortCoolingSubtype,
    setComfortCoolingSubtype,
    comfortCoolingSubOptions,
    setComfortCoolingSubOptions,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    materialType,
    setMaterialType,
    systemStatus,
    setSystemStatus,
    currentGasWeightLBS,
    setCurrentGasWeightLBS,
    currentGasWeightOZ,
    setCurrentGasWeightOZ,
    ratedCoilTemperature,
    setRatedCoilTemperature,
    chargeCapacityLBS,
    setChargeCapacityLBS,
    chargeCapacityOZ,
    setChargeCapacityOZ,
    chargeCapacityDeterminedBy,
    setChargeCapacityDeterminedBy,
    temperatureClass,
    setTemperatureClass,
    coolingCapacity,
    setCoolingCapacity,
    SEER,
    setSEER,
    EER,
    setEER,
    ESEER,
    setESEER,
    oilType,
    setOilType,
    alternateLeakDetectionMethod,
    setAlternateLeakDetectionMethod,
    leakDetectionDetails,
    setLeakDetectionDetails,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    amps,
    setAmps,
    voltage,
    setVoltage,
    hertz,
    setHertz,
    phase,
    setPhase,
    systemManager,
    setSystemManager,
    hermeticallySealed,
    setHermeticallySealed,
    energySourceType,
    setEnergySourceType,
    ErrorObject,
    systemManagers,
    leakMonitorDevice,
    setLeakMonitorDevice,
    id,
}) => {
    const [isCalifornia, setIsCalifornia] = useState(false)
    const [leakMonitorDeviceOptions, setLeakMonitorDeviceOptions] = useState([]);
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");

    const { handleLocationChange, subLocations } = useGetLocationForDropdown({
        onChangeLocation: setLocation,
        onChangeSubLocation: setSubLocation,
        location
    });

    const onAlternateLeakDetectionMethodStatusChanged = (e) => {
        const {
            value
        } = e.target;

        setAlternateLeakDetectionMethod(value === 1 || value === 2 ? e.target.value === 1 : null);
    }

    const GetLeakMonitorDevices = async function (location) {
        const response = await fetch(Routes.Asset.GetLeakMonitorDevices(location));
        const data = await response.json();

        if (data.length > 0) {
            setLeakMonitorDeviceOptions(data)
        }

        return data;
    }

    useEffect(() => {
        setSystemType(system_type_options[0].value);
    }, []);

    useEffect(() => {
        const loc = locations.find(x => x.value === location);
        GetLeakMonitorDevices(location);
        if (loc) {
            setState(loc.state);
            setCountry(loc.country);
            setIsCalifornia(loc.state === "CA");
        } else {
            setState("");
            setCountry("");
            setIsCalifornia(false)
        }
    }, [location])

    useEffect(() => {
        if (comfortCoolingType === 10) setComfortCoolingSubOptions(air_conditioning_options);
        if (comfortCoolingType === 11) setComfortCoolingSubOptions(chiller_options);
        if (comfortCoolingType === 29) setComfortCoolingSubOptions(other_options);
    }, [comfortCoolingType])

    return (
        <CreateInventoryFormPanel enabled={!id} flattenStackedFields>
            {/* first row along with inventory type */}
            <FormFieldItem {...formFieldGridColumns}>
                <Select
                    value={subLocation}
                    label={TranslateW("assetDetailsMainTab.subLocation")}
                    options={subLocations}
                    onChange={(e) => setSubLocation(e.target.value)}
                />
            </FormFieldItem>
            {/* actual rows  */}
            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Input
                        required
                        fullWidth
                        label="Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        error={ErrorObject.Name}
                        helperText={typeof ErrorObject.Name === 'string' ? ErrorObject.Name : undefined}
                    />
                    <Select
                        required
                        value={location}
                        label={TranslateW("assetDetailsDashboardTab.location")}
                        options={locations}
                        onChange={handleLocationChange}
                        error={ErrorObject.location}
                    />
                    <Input
                        fullWidth
                        label="Country"
                        disabled
                        value={country}
                    />
                    <Input
                        fullWidth
                        label="State"
                        disabled
                        value={state}
                    />
                </Stack>
            </FormFieldItem>
            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        disabled
                        value={systemType}
                        label="System Type"
                        options={system_type_options}
                        onChange={e => setSystemType(e.target.value)}
                    />
                    <Select
                        value={comfortCoolingType}
                        label="Comfort Cooling Type"
                        options={comfort_cooling_options}
                        onChange={e => setComfortCoolingType(e.target.value)}
                        sx={{
                            marginTop: "3px"
                        }}
                    />
                    {
                        comfortCoolingType !== null && (
                            <Select
                                value={comfortCoolingSubtype}
                                label="Sub Type"
                                options={comfortCoolingSubOptions}
                                onChange={e => setComfortCoolingSubtype(e.target.value)}
                                sx={{
                                    marginBottom: "3px"
                                }}
                            />
                        )
                    }
                    <Input
                        fullWidth
                        required={isCalifornia}
                        multiLine
                        label="Location On Site"
                        value={locationOnSite}
                        onChange={e => setLocationOnsite(e.target.value)}
                        error={ErrorObject.LocationOnSite}
                        customHelperText={ErrorObject.LocationOnSite}
                    />
                </Stack>
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        required
                        value={materialType}
                        label="Material Type"
                        options={materialTypes}
                        onChange={e => setMaterialType(e.target.value)}
                        error={ErrorObject.MaterialType}
                        customHelperText={ErrorObject.MaterialType}
                    />
                    <Grid container>
                        <WeightInput
                            required
                            removePadding
                            showConversionArrows
                            headerColor={"#656565"}
                            lbsError={ErrorObject.CurrentGasWeightLBS}
                            customHelperText={ErrorObject.CurrentGasWeightLBS}
                            header="Current Gas Weight"
                            variant="standard"
                            value={currentGasWeightLBS}
                            onChange={(e) => { setCurrentGasWeightLBS(Number(e)) }}
                            columnSpan={5}
                        />
                    </Grid>
                </Stack>
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Grid container>
                        <WeightInput
                            required
                            removePadding
                            showConversionArrows
                            headerColor={"#656565"}
                            header="Charge Capacity"
                            variant="standard"
                            value={chargeCapacityLBS}
                            lbsError={ErrorObject.ChargeCapacity}
                            customHelperText={ErrorObject.ChargeCapacity}
                            onChange={(e) => setChargeCapacityLBS(e)}
                            columnSpan={5}
                        />
                    </Grid>
                    <Select
                        required
                        label="Charge Capacity Determined By"
                        value={chargeCapacityDeterminedBy}
                        options={charge_capacity_source_type}
                        onChange={e => setChargeCapacityDeterminedBy(e.target.value)}
                        error={ErrorObject.ChargeCapacityDeterminedBy}
                        customHelperText={ErrorObject.ChargeCapacityDeterminedBy}
                    />
                </Stack >
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        required
                        value={assetStatus}
                        label="Asset Status"
                        options={asset_status_options}
                        onChange={e => setAssetStatus(e.target.value)}
                        error={ErrorObject.AssetStatus}
                    />
                    <DateInput
                        allowPast
                        date={acquisitionDate}
                        required
                        onChange={date => setAquisitionDate(date)}
                        label={`Acquisition Date ${id ? " " : "*"}`}
                        error={ErrorObject.AcquisitionDate}
                        customHelperText={ErrorObject.AcquisitionDate}
                    />
                    <DateInput
                        allowFuture={false}
                        allowPast={true}
                        date={disbursementDate}
                        onChange={date => setDisbursementDate(date)}
                        label="Disbursement Date"
                        disabled={assetStatus === 1}
                    />
                </Stack>
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        required
                        value={systemStatus}
                        label="System Status"
                        options={system_status_options}
                        onChange={e => setSystemStatus(e.target.value)}
                        error={ErrorObject.SystemStatus}
                    />
                    <DateInput
                        allowPast
                        date={installDate}
                        required
                        onChange={date => setInstallDate(date)}
                        label={`Install Date ${id ? " " : "*"}`}
                        error={ErrorObject.InstallDate}
                        customHelperText={ErrorObject.InstallDate}
                    />
                    <Select
                        label="Alternate Leak Detection Method Status"
                        value={alternateLeakDetectionMethod != null ? (alternateLeakDetectionMethod ? 1 : 2) : null }
                        options={[{ value: 1, label: "Approved" }, { value: 2, label: "Disapproved" }]}
                        onChange={onAlternateLeakDetectionMethodStatusChanged}
                    />
                    {
                        alternateLeakDetectionMethod && (
                            <>
                                <Input
                                    fullWidth
                                    multiLine
                                    label="Approved Alternate Leak Detection Details"
                                    value={leakDetectionDetails}
                                    onChange={e => setLeakDetectionDetails(e.target.value)}
                                />
                                <Select
                                    value={leakMonitorDevice}
                                    label="Associated Leak Monitoring Device"
                                    options={leakMonitorDeviceOptions}
                                    onChange={e => setLeakMonitorDevice(e.target.value)}
                                />
                            </>
                        )
                    }
                </Stack>
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        value={manufacturer}
                        required={isCalifornia}
                        label="Manufacturer"
                        options={manufacturers}
                        onChange={e => setManufacturer(e.target.value)}
                        error={ErrorObject.Manufacturer}
                        customHelperText={ErrorObject.Manufacturer}
                    />
                    <Input
                        required={serialNumber == null || serialNumber == ""}
                        fullWidth
                        label="Tag Number"
                        value={tagNumber}
                        onChange={e => setTagNumber(e.target.value)}
                        error={ErrorObject.TagNumber}
                        helperText={typeof ErrorObject.TagNumber === 'string' ? ErrorObject.TagNumber : undefined}
                    />
                    <Input
                        required={tagNumber == null || tagNumber == ""}
                        fullWidth
                        label="Serial Number"
                        value={serialNumber}
                        onChange={e => setSerialNumber(e.target.value)}
                        error={ErrorObject.SerialNumber}
                        helperText={typeof ErrorObject.SerialNumber === 'string' ? ErrorObject.SerialNumber : undefined}
                    />
                    <Input
                        required={isCalifornia}
                        fullWidth
                        label="Model Number"
                        value={modelNumber}
                        onChange={e => setModelNumber(e.target.value)}
                        error={ErrorObject.ModelNumber}
                        customHelperText={ErrorObject.ModelNumber}
                    />
                    <DateInput
                        allowPast
                        allowFuture={false}
                        date={manufactureDate}
                        onChange={date => setManufactureDate(date)}
                        label="Manufacturer Date"
                        error={ErrorObject.ManufactureDate}
                        customHelperText={ErrorObject.ManufactureDate}
                    />
                </Stack>
            </FormFieldItem>

            <FormFieldItem {...formFieldGridColumns}>
                <Stack spacing={"25px"}>
                    <Select
                        required={isCalifornia}
                        value={modelYear}
                        label="Model Year"
                        options={years}
                        onChange={e => setModelYear(e.target.value)}
                        error={ErrorObject.ModelYear}
                        customHelperText={ErrorObject.ModelYear}
                    />
                    <Select
                        required
                        value={temperatureClass}
                        label="Temperature Class"
                        options={temp_class_options}
                        onChange={e => setTemperatureClass(e.target.value)}
                        error={ErrorObject.TemperatureClass}
                    />
                    <Select
                        value={newPurchaseAquisition}
                        label="Purchase / acquisition Status?"
                        options={acquisition_status_options}
                        onChange={e => setNewPurchaseAquisition(e.target.value)}
                        error={ErrorObject.NewPurchaseAquisition}
                    />
                    {
                        newPurchaseAquisition === 0 && (
                            <Select
                                required
                                disabled={id != ''}
                                value={aquireLocation}
                                label="Acquired From Location"
                                options={aquireLocationsOptions}
                                onChange={e => setAquireLocation(e.target.value)}
                                error={ErrorObject.AquireLocation}
                            />
                        )
                    }
                    <Select
                        value={hermeticallySealed}
                        label="Hermetically Sealed?"
                        options={yes_no_options}
                        onChange={e => setHermeticallySealed(e.target.value)}
                        sx={{ marginTop: "3px" }}
                    />
                </Stack>
            </FormFieldItem>
            <MoreFields>
                        <FormFieldItem {...formFieldGridColumns}>
                            <Stack spacing={"25px"}>
                                <Input
                                    fullWidth
                                    label="Cooling Capacity"
                                    value={coolingCapacity}
                                    onChange={e => setCoolingCapacity(e.target.value)}
                                />
                                <Input
                                    disabled
                                    fullWidth
                                    label="Rated Coil Temperature (F)"
                                    value={ratedCoilTemperature}
                                    onChange={e => setRatedCoilTemperature(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    label="SEER"
                                    value={SEER}
                                    onChange={e => setSEER(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    multiLine
                                    label="EER"
                                    value={EER}
                                    onChange={e => setEER(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    multiLine
                                    label="ESEER"
                                    value={ESEER}
                                    onChange={e => setESEER(e.target.value)}
                                />
                                <Select
                                    value={oilType}
                                    label="Oil Type"
                                    options={oil_type_options}
                                    onChange={e => setOilType(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    label="Brand"
                                    value={brand}
                                    onChange={e => setBrand(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    type="number"
                                    label="PO Number"
                                    value={poNumber}
                                    onChange={e => setPONumber(e.target.value)}
                                />
                            </Stack>
                        </FormFieldItem>

                        <FormFieldItem {...formFieldGridColumns}>
                            <Stack spacing={"25px"}>
                                <Select
                                    value={lifeTime}
                                    label="Expected Lifetime (years)"
                                    options={lifeTimeOptions}
                                    onChange={e => setLifeTime(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    type="number"
                                    label="Amps"
                                    value={amps}
                                    onChange={e => setAmps(e.target.value)}
                                />
                                <Input
                                    fullWidth
                                    type="number"
                                    label="Voltage"
                                    value={voltage}
                                    onChange={e => setVoltage(e.target.value)}
                                />
                                <Select
                                    value={hertz}
                                    label="Hertz"
                                    options={hertz_options}
                                    onChange={e => setHertz(e.target.value)}
                                />
                                <Select
                                    value={phase}
                                    label="Phase"
                                    options={phase_options}
                                    onChange={e => setPhase(e.target.value)}
                                    sx={{ marginTop: "3px" }}
                                />
                                <Select
                                    value={systemManager}
                                    label="System Manager"
                                    options={systemManagers}
                                    onChange={e => setSystemManager(e.target.value)}
                                    sx={{ marginTop: "3px" }}
                                />
                                <Select
                                    value={energySourceType}
                                    label="Energy Source Type"
                                    options={energy_source_type_options}
                                    onChange={e => setEnergySourceType(e.target.value)}
                                />
                            </Stack>
                        </FormFieldItem>
            </MoreFields>
        </CreateInventoryFormPanel>
    );
};

ComfortCooling.propTypes = {
    newPurchaseAquisition: PropTypes.array.isRequired,
    setNewPurchaseAquisition: PropTypes.object.isRequired,
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    systemType: PropTypes.string.isRequired,
    setSystemType: PropTypes.func.isRequired,
    system_status_options: PropTypes.array.isRequired,
    comfortCoolingType: PropTypes.string.isRequired,
    setComfortCoolingType: PropTypes.func.isRequired,
    comfortCoolingSubtype: PropTypes.string.isRequired,
    setComfortCoolingSubtype: PropTypes.func.isRequired,
    comfortCoolingSubOptions: PropTypes.string.isRequired,
    setComfortCoolingSubOptions: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    materialType: PropTypes.string.isRequired,
    setMaterialType: PropTypes.func.isRequired,
    systemStatus: PropTypes.string.isRequired,
    currentGasWeightLBS: PropTypes.string.isRequired,
    setCurrentGasWeightLBS: PropTypes.func.isRequired,
    currentGasWeightOZ: PropTypes.string.isRequired,
    setCurrentGasWeightOZ: PropTypes.func.isRequired,
    ratedCoilTemperature: PropTypes.string.isRequired,
    setRatedCoilTemperature: PropTypes.func.isRequired,
    chargeCapacityLBS: PropTypes.string.isRequired,
    setChargeCapacityLBS: PropTypes.func.isRequired,
    chargeCapacityOZ: PropTypes.string.isRequired,
    setChargeCapacityOZ: PropTypes.func.isRequired,
    chargeCapacityDeterminedBy: PropTypes.string.isRequired,
    setChargeCapacityDeterminedBy: PropTypes.func.isRequired,
    temperatureClass: PropTypes.string.isRequired,
    setTemperatureClass: PropTypes.func.isRequired,
    coolingCapacity: PropTypes.string.isRequired,
    setCoolingCapacity: PropTypes.func.isRequired,
    SEER: PropTypes.string.isRequired,
    setSEER: PropTypes.func.isRequired,
    EER: PropTypes.string.isRequired,
    setEER: PropTypes.func.isRequired,
    ESEER: PropTypes.string.isRequired,
    setESEER: PropTypes.func.isRequired,
    oilType: PropTypes.string.isRequired,
    setOilType: PropTypes.func.isRequired,
    alternateLeakDetectionMethod: PropTypes.string.isRequired,
    setAlternateLeakDetectionMethod: PropTypes.func.isRequired,
    leakDetectionDetails: PropTypes.string.isRequired,
    setLeakDetectionDetails: PropTypes.func.isRequired,
    setSystemStatus: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    setAmps: PropTypes.func.isRequired,
    amps: PropTypes.string.isRequired,
    voltage: PropTypes.string.isRequired,
    setVoltage: PropTypes.func.isRequired,
    hertz: PropTypes.string.isRequired,
    setHertz: PropTypes.func.isRequired,
    phase: PropTypes.string.isRequired,
    setPhase: PropTypes.func.isRequired,
    systemManager: PropTypes.string.isRequired,
    setSystemManager: PropTypes.func.isRequired,
    hermeticallySealed: PropTypes.string.isRequired,
    setHermeticallySealed: PropTypes.func.isRequired,
    energySourceType: PropTypes.string.isRequired,
    setEnergySourceType: PropTypes.func.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default ComfortCooling;
